import '../sass/project.scss';


// Import all of Bootstrap's JS
import { Alert, Collapse, Tooltip, Popover, Dropdown, Offcanvas } from 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css';
window.bootstrap = {
  Alert, Collapse, Tooltip, Popover, Dropdown, Offcanvas
}

/* Project specific Javascript goes here. */
